<style lang="less" scoped></style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">版本管理</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">厂商标识</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.manufactorId"
                clearable
              >
                <el-option v-for="item in manufactors" :label="item" :value="item" :key="item"></el-option>
                
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩型号</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.pileTypeNo"
                  clearable
                  no-data-text="暂无数据"
                @focus="getPileList"
              >
               
                <el-option v-for="item in pile" :label="item.pileTypeName" :value="item.pileTypeNo" :key="item.pileTypeNo"></el-option>
                
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex" style="white-space: nowrap;">
            <div class="query-title-div">版本下发状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.checkedStatus"
                clearable
              >
                <el-option label="未下发" value="1"></el-option>
                <el-option label="已下发" value="0"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">当前版本号</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.currentVersionNo"
                clearable
              >
                <el-option v-for="(item,index) in versionNo" :label="item" :value="item" :key="index"></el-option>
                
              </el-select>
            </div>
          </div>
        </template>
        <template slot="actions">
          <div class="">
            <button
              class="common-bg-button"
              @click="getListData(pagination, true)"
            >
              搜 索
            </button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
        </template>
      </ZD-list-querys>
      <div class="page-action-btns flex" style="margin-bottom:10px;">
        <button class="common-bg-button" @click="listAddFun()">新增</button>
        <button class="common-bg-button" @click="listEditFun()">编 辑</button>
        <button class="common-bg-button" @click="Issued()">下 发</button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table
          :data="listData"
          ref="IssuedTable"
          :stripe="true"
          class="list_tb"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
          ></el-table-column>
          <el-table-column
            type="index"
            align="center"
            width="55"
          ></el-table-column>
          <el-table-column
            prop="manufactorId"
            label="厂商标识"
            min-width="110"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="pile"
            label="充电桩型号名称"
            min-width="170"
            align="center"
          >
          <template slot-scope="scope">
             {{scope.row.pile[0].pileTypeName}}
          </template>
          </el-table-column>
          <el-table-column
            prop="versionNo"
            label="最新版本号"
            min-width="170"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="versionDesc"
            label="版本描述"
            min-width="170"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="versionDownloadPath"
            label="版本下载路径"
            min-width="240"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="checkedStatusName"
            label="版本下发"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="checkedTime"
            label="版本下发时间"
            min-width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createdByName"
            label="创建者"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createdWhen"
            label="创建时间"
            min-width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="lastModifiedByName"
            label="更新者"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="lastModifiedWhen"
            label="更新时间"
            min-width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="invokeFlag"
            label="查看"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="lookHistory(scope.row)"
                >历史版本</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getListData"
          ></ZD-pagination>
        </div> -->
        <el-dialog title="版本下发" width="30%" :visible.sync="IssuedVisible">
          <div style="text-align:center;">
            是否确认将已选择充电桩的最新设备版本下发至APP用户？<br/>
（下发后，用户可在APP搜索到设备最新版本，手动更新版本）
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="IssuedVisible = false">取 消</el-button>
            <el-button type="primary" @click="yesIssued"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import utils from '../../../utils/utils';
export default {
  data() {
    return {
      versionNo:[],
      pile:[],
      manufactors:[],
      IssuedList:[],
        IssuedVisible:false,
      pageConfig: pageConfig, // 页面配置
      listData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {
        // messageType: null,
        // messageStatus: null,
        // sendStatus: null,
        // invokeFlag: null,
      },
      switchArr: [], //启用状态
      srcList: [], //大图地址
      switchUse: "02", //使用状态
    };
  },
  methods: {
    init() {
      this.getListData(this.pagination, true);
      this.getManufactors()
      this.getVersionNo()
    },

    // 获取厂商标识
    getManufactors() {
      let _ = this;
      _.$H.get(_, _.$A.pile.listManufactorId).then((res) => {
       _.manufactors = res.data.data
      });
      
    },

    getPileList(){
    if(this.queryInfo.manufactorId == '' || this.queryInfo.manufactorId == null){
      return  utils.error('请选择厂商');
    }else{
      this.getPile(this.queryInfo.manufactorId);
    }
    },

    // 获取版本号

    getVersionNo(){
      let _ = this;
      _.$H.post(_, _.$A.custVersion.version,{}).then((res) => {
        console.log(res);
       _.versionNo = res.data.data.map((item)=>{
        return item.versionNo
       })
       console.log(_.versionNo);
      });
      
    },


    // 获取充电桩
    getPile(id) {
      let _ = this;
      _.$H.post(_, _.$A.pile.listFeign, {manufactorId:id}).then((res) => {
        console.log(res.data);
        _.pile = res.data.data.map((item) => {
          return {
            pileTypeName: item.pileTypeName,
            pileTypeNo: item.pileTypeNo,
     
          };
        });
       
      });
    },

    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.$H.get(_, _.$A.mobile.findList, _.queryInfo).then((res) => {
      _.$H.post(_, _.$A.custVersion.page, _.queryInfo).then((res) => {
        _.listData = res.data.data || [];
     
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
   
    // 查看历史版本
    lookHistory(row){
      this.$router.push({
          name: "versionDetail",
          params: {
            isFlag:true,
            selections: row,
          },
        })
    },
    //选中表格
    handleSelectionChange(e) {
      // console.log(e);
      this.selections = e;
    },
    //重置
    reset() {
      this.queryInfo = {
        messageType: null,
        messageStatus: null,
        currentVersionNo:null,
        sendStatus: null,
        invokeFlag: null,
      };
      this.pagination.current = 1;
      this.getListData(this.pagination);
    },
    
    //页面新增方法
    listAddFun() {
      localStorage.removeItem('versionDetail')
      this.$S.listAddFun(this, pageConfig.tableEditObj);
    },
    // 页面编辑方法
    listEditFun() {
      let _ = this;
      // this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
      //   this.$store.commit('setEditId', _.selections[0].pileCode);
      // _.$router.push({ name: 'pileDetail' });
      if (_.selections.length <= 0) {
        utils.error('请选择需要操作的记录');
        return;
    } else if (_.selections.length > 1) {
        utils.error('请选择一条记录进行操作');
        return;
    }else{
      // console.log(_.selections);
      // Cookies.remove('versionDetail')
      localStorage.removeItem('versionDetail')
      localStorage.setItem('versionDetail', JSON.stringify(_.selections[0]))
      // Cookies.set('versionDetail', JSON.stringify(_.selections[0]))
        this.$router.push({
          name: "versionDetail",
          params: {
            selections: _.selections[0],
          },
        })
    }
      
    },
    Issued() {
      let _ = this
      if (_.selections.length <= 0) {
        utils.error('请选择需要操作的记录');
        return;
    }else if (_.selections.length > 1) {
        utils.error('请选择一条记录进行操作');
        return;
    }else{
      _.IssuedList = [];
      _.selections.forEach(item=>{
        _.IssuedList.push(item.id)
      })
      _.IssuedVisible = true
    }
        
    },
    yesIssued(){
      let _ = this;
      _.$U.showLoading(_);
      _.IssuedList = _.IssuedList.join(',')
      let obj = {

      }
      obj.id = _.IssuedList
      _.$H.post(_, _.$A.custVersion.check, obj).then((res) => {
        _.IssuedVisible = false
        _.$refs.IssuedTable.clearSelection()
        _.$U.hideLoading(_);
        utils.success('已下发');
        _.getListData(this.pagination, true)
        })
    }
  },
  mounted() {
    this.init();
  },
};
</script>
